import { ReportGroup } from "../models/reports.groups";
import BaseService from "./_base.service";

const endpoint = "groups/reports";

const ReportsGroupsService = {
  ...BaseService<ReportGroup>({ endpoint }),
};

export default ReportsGroupsService;
